<template>
    <button class="toggle"
            :class="{
                'is-active': active,
                'is-rotated': rotated,
            }"
            @click="handleClick"
    >
        <o-icon icon="bars" pack="fas" v-if="active" />
        <o-icon icon="chevron-left" pack="fas" class="arrow" v-else />
    </button>
</template>

<script setup lang="ts">

  import {toRefs} from "vue";

  const emit = defineEmits< {
    'click': [],
  }>();

  const props = withDefaults(defineProps<{
    active?: boolean,
    rotated?: boolean,
  }>(),{
    active: false,
    rotated: false,
  });
  const {
    active,
    rotated,
  } = toRefs(props);

  function handleClick() {
    emit('click');
  }

</script>

<style lang="scss" scoped>
  $toggle-size: 32px;
    .toggle {
        background: var(--nav-secondary-background);
        align-items: center;
        border: 1px solid var(--nav-background-dark);
        border-radius: 50%;
        color: var(--nav-secondary-text);
        stroke: var(--nav-secondary-text);
        stroke-width: 1.5px;
        font-weight:700;
        cursor: pointer;
        display: flex;
        height: $toggle-size;
        justify-content: center;
        outline: none;
        width: $toggle-size;

        .icon {
            align-items: center;
            display: flex;
            height: $toggle-size*.8;
            justify-content: center;
            position: relative;
            transition: left .4s, top .4s, transform .4s;
            width:$toggle-size*.8;

            &.arrow {
                top: 1px;
            }
        }

        &.is-rotated {
            .icon {
                left: 1px;
                top: 0;
                transform: rotate(180deg);
            }
        }
    }
</style>